/**
 * AIHelpers - Re-exports from modular ai-helpers components
 * 
 * This file maintains backwards compatibility with existing imports.
 * New imports should use '@/components/ai-helpers' directly.
 * 
 * Architecture: See /app/frontend/src/components/ai-helpers/
 */
export { 
  AIEmailHelper, 
  AIForumReplyHelper, 
  AIHomeworkFeedbackHelper, 
  AIForumPostHelper 
} from './ai-helpers';

export default { 
  AIEmailHelper: () => import('./ai-helpers').then(m => m.AIEmailHelper),
  AIForumReplyHelper: () => import('./ai-helpers').then(m => m.AIForumReplyHelper),
  AIHomeworkFeedbackHelper: () => import('./ai-helpers').then(m => m.AIHomeworkFeedbackHelper),
  AIForumPostHelper: () => import('./ai-helpers').then(m => m.AIForumPostHelper)
};
